import "@/App.css";
import FlappyPepe from "@/game/FlappyPepe";

function App() {
  return <FlappyPepe />;
}

export default App;
